import { getEnv } from "@/env";
import { COUNTRIES_BY_DIAL_CODE } from "@/react/features/countriesByDialCode";

const PRODUCTION = "production";

export const PROTOCOL = Object.freeze({
  TCP: "TCP",
  UDP: "UDP",
});

export const DEFAULT_IP_BOX = Object.freeze({
  ipAddress: "",
  protocol: PROTOCOL.TCP,
  priority: null,
  weight: null,
  port: null,
});

export const getDefaultTrunkGateway = (customerId) => ({
  name: "",
  brand: BRAND,
  proxyServer: PROXY_SERVER,
  customerId,
  boxes: [DEFAULT_IP_BOX],
  additionalBoxes: [],
  licenseId: "",
  loginId: "",
  password: "",
  subscriberDetails: {
    firstName: "",
    lastName: "",
    email: "",
    serviceCountry: null,
    brandId: BRAND_ID,
  },
});

export const CREATE_TRUNK_GATEWAY_FIELDS = Object.freeze({
  main: [
    {
      label: "*Gateway Name",
      path: "name",
    },
    {
      label: "*Gateway Brand",
      path: "brand",
      disabled: true,
    },
    {
      label: "*Proxy Server",
      path: "proxyServer",
      disabled: true,
    },
  ],
  subscriberDetails: [
    {
      label: "*First Name",
      path: "subscriberDetails.firstName",
    },
    {
      label: "*Last Name",
      path: "subscriberDetails.lastName",
    },
    {
      label: "*Email",
      path: "subscriberDetails.email",
    },
    {
      label: "*Brand ID",
      path: "subscriberDetails.brandId",
      disabled: true,
    },
  ],
});

export const PROXY_SERVER = "eps1.packet8.net:5060";
export const BRAND = "gtg";

export const BRAND_ID = getEnv("VUE_APP_NODE_ENV") === PRODUCTION ? 50 : 1;

export const IP_BOXES_KEY = Object.freeze({
  BOX: "boxes",
  ADDITIONAL_BOX: "additionalBoxes",
});

export const ADDRESS_MODAL_ACTIONS = Object.freeze({
  CREATE: "create",
  EDIT: "edit",
});

export const COUNTRY_CODES = Object.values(COUNTRIES_BY_DIAL_CODE)
  .flat(1)
  .map((c) => ({
    value: c.code,
    label: c.name,
  }));
